import { OrderSummary } from '@common/order-summary';

export interface AdminOrdersState {
  orders: OrderSummary[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  isLoading: boolean;
  error: any;
}

export const initialState: AdminOrdersState = {
  orders: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  isLoading: false,
  error: null
};
